import { SuggestionOption } from '../components/MultiColumnAutoComplete/MultiColumnAutoCompleteExample/types';

export function isAIFilterOption(option: SuggestionOption) {
  return option.id.endsWith('aiFilter');
}
